"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroupAddon = void 0;
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InputGroupAddon = (0, _styledComponents.default)(_reactstrap.InputGroupText)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 40px;\n  left: ", ";\n  right: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  position: absolute;\n  z-index: 1;\n  background: transparent;\n  border: none;\n"])), function (_ref) {
  var addonType = _ref.addonType;
  return addonType === 'prepend' && 0;
}, function (_ref2) {
  var addonType = _ref2.addonType;
  return addonType === 'append' && 0;
}, function (_ref3) {
  var addonType = _ref3.addonType;
  return addonType === 'prepend' ? '18px' : 0;
}, function (_ref4) {
  var addonType = _ref4.addonType;
  return addonType === 'append' ? '18px' : 0;
});
exports.InputGroupAddon = InputGroupAddon;